import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    Label,
    Input,
} from "reactstrap";

import * as Icon from "react-feather";

import SearchUserInput from "./SearchUserInput";


const FilterForm = ({ loading, userId, plans, addons, mergeFilters }) => {

    const [filters, setFilters] = useState({
        userId: userId,
        selectedPlans: [],
        selectedAddons: [],
        selectedOverdues: [],
        selectedStorages: [],
        selectedRevenues: [],
        reload: false,
    });

    const handleSubscriberChange = (option) => {
        setFilters({ ...filters, userId: option ? option.value : undefined });
    }

    const handlePlanSelectionChanges = (option) => {
        if (filters.selectedPlans.includes(option)) {
            setFilters({ ...filters, selectedPlans: filters.selectedPlans.filter((item) => item !== option), reload: true });
        } else {
            setFilters({ ...filters, selectedPlans: [...filters.selectedPlans, option], reload: true });
        }
    }

    const handleAddonSelectionChanges = (option) => {
        if (filters.selectedAddons.includes(option)) {
            setFilters({ ...filters, selectedAddons: filters.selectedAddons.filter((item) => item !== option), reload: true });
        } else {
            setFilters({ ...filters, selectedAddons: [...filters.selectedAddons, option], reload: true });
        }
    }

    const handlePaymentSelectionChanges = (option) => {
        if (filters.selectedOverdues.includes(option)) {
            setFilters({ ...filters, selectedOverdues: filters.selectedOverdues.filter((item) => item !== option), reload: true });
        } else {
            setFilters({ ...filters, selectedOverdues: [option], reload: true });
        }
    }

    const handleStorageSelectionChanges = (option) => {
        if (filters.selectedStorages.includes(option)) {
            setFilters({ ...filters, selectedStorages: filters.selectedStorages.filter((item) => item !== option), reload: true });
        } else {
            setFilters({ ...filters, selectedStorages: [option], reload: true });
        }
    }

    const handlePayoutsSelectionChanges = (option) => {
        if (filters.selectedRevenues.includes(option)) {
            setFilters({ ...filters, selectedRevenues: filters.selectedRevenues.filter((item) => item !== option), reload: true });
        } else {
            setFilters({ ...filters, selectedRevenues: [option], reload: true });
        }
    }

    const handleFilterFormSubmit = () => {
        mergeFilters && mergeFilters({ ...filters, pageNumber: 1, reload: true });
    }

    return (
        <Container fluid className="p-0">
            <Row className="align-items-end">
                <Col lg="3" >
                    <label className="mb-1 font-weight-bold">User</label>
                    <SearchUserInput
                        onChange={handleSubscriberChange}
                        className="w-100"
                        isClearable={true}
                        name="subsId"
                    />
                </Col>
                <Col lg="6" >
                    <div>
                        <div><label className="mb-1 font-weight-bold">Base plans</label></div>
                        <div className="d-flex" style={{ gap: '1rem', justifyContent: "center", alignItems: 'center', border: 'solid 1px rgb(207, 213, 219)' }}>
                            {plans && plans.map((option, index) => (
                                <div key={index} className="ml-2 mt-1">
                                    <Input
                                        type="checkbox"
                                        id={`plan-${index}`}
                                        checked={filters.selectedPlans.includes(option.planName)}
                                        onChange={() => handlePlanSelectionChanges(option.planName)}
                                        className="ml-0"
                                    />
                                    <Label for={`plan-${index}`} className="ml-4">
                                        {option.name}
                                    </Label>
                                </div>
                            ))}
                        </div>
                    </div>
                </Col>
                <Col lg="3">
                    <div>
                        <div><label className="mb-1 font-weight-bold">Additional plans</label></div>
                        <div className="d-flex" style={{ gap: '1rem', justifyContent: "center", alignItems: 'center', border: 'solid 1px rgb(207, 213, 219)' }}>
                            {addons && addons.map((option, index) => (
                                <div key={index} className="ml-2 mt-1">
                                    <Input
                                        type="checkbox"
                                        id={`addon-${index}`}
                                        checked={filters.selectedAddons.includes(option.planName)}
                                        onChange={() => handleAddonSelectionChanges(option.planName)}                                        
                                        className="ml-0"
                                    />
                                    <Label for={`addon-${index}`} className="ml-4">
                                        {option.name}
                                    </Label>
                                </div>
                            ))}
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className="mt-2 align-items-end">
                <Col lg="2">
                    <div>
                        <div><label className="mb-1 font-weight-bold">Overdue payment ?</label></div>
                        <div className="d-flex" style={{ gap: '1rem', justifyContent: "center", alignItems: 'center', border: 'solid 1px rgb(207, 213, 219)' }}>
                            {["Yes", "No"].map((option, index) => (
                                <div key={index} className="ml-2 mt-1">
                                    <Input
                                        type="checkbox"
                                        id={`payment-${index}`}
                                        checked={filters.selectedOverdues.includes(option)}
                                        onChange={() => handlePaymentSelectionChanges(option)}
                                        className="ml-0"
                                    />
                                    <Label for={`payment-${index}`} className="ml-4">
                                        {option}
                                    </Label>
                                </div>
                            ))}
                        </div>
                    </div>
                </Col>

                <Col lg="2">
                    <div>
                        <div><label className="mb-1 font-weight-bold">Exceeded storage ?</label></div>
                        <div className="d-flex" style={{ gap: '1rem', justifyContent: "center", alignItems: 'center', border: 'solid 1px rgb(207, 213, 219)' }}>
                            {["Yes", "No"].map((option, index) => (
                                <div key={index} className="ml-2 mt-1">
                                    <Input
                                        type="checkbox"
                                        id={`storage-${index}`}
                                        checked={filters.selectedStorages.includes(option)}
                                        onChange={() => handleStorageSelectionChanges(option)}
                                        className="ml-0"
                                    />
                                    <Label for={`storage-${index}`} className="ml-4">
                                        {option}
                                    </Label>
                                </div>
                            ))}
                        </div>
                    </div>
                </Col>

                <Col lg="2">
                    <div>
                        <div><label className="mb-1 font-weight-bold">Payouts finished ?</label></div>
                        <div className="d-flex" style={{ gap: '1rem', justifyContent: "center", alignItems: 'center', border: 'solid 1px rgb(207, 213, 219)' }}>
                            {["Yes", "No"].map((option, index) => (
                                <div key={index} className="ml-2 mt-1">
                                    <Input
                                        type="checkbox"
                                        id={`payout-${index}`}
                                        checked={filters.selectedRevenues.includes(option)}
                                        onChange={() => handlePayoutsSelectionChanges(option)}
                                        className="ml-0"
                                    />
                                    <Label for={`payout-${index}`} className="ml-4">
                                        {option}
                                    </Label>
                                </div>
                            ))}
                        </div>
                    </div>
                </Col>

                <Col lg="5">
                </Col>
                <Col lg="1" className="align-items-end">
                    <div className="d-flex justify-content-end">

                        <Button
                            className=""
                            size=""
                            disabled={loading}
                            onClick={handleFilterFormSubmit}
                            style={{ minWidth: '86px' }}
                        >
                            <Icon.Search style={{ width: '15px', height: '15px', marginTop: '-2px' }} /> Search
                        </Button>
                    </div>
                </Col>
            </Row>
        </Container >
    );
};

export default FilterForm;
